import base from './base'

export default {
  ...base,
  colors: {
    ...base.colors,
    shadow1: '#000',
    text1: '#FFFFFF',
    text2: '#C3C5CB',
    text3: '#6C7284',
    text4: '#565A69',

    // backgrounds / greys
    bg0: '#2F2E2D',
    bg1: '#3D3D3D',
    bg2: '#2F2E2D',
    bg3: '#40444F',
    bg4: '#565A69',
    bg5: '#6C7284',

    //specialty colors
    modalBG: 'rgba(0,0,0,.425)',
    advancedBG: 'rgba(0,0,0,0.1)',

    //primary colors
    primary1: '#6E84FB',
    primary4: '#376bad70',
    primary5: '#153d6f70',

    // color text
    primaryText1: '#6da8ff',
    buttonText: '#ffffff',

    // secondary colors
    secondary1: '#24c7d6',
    bg: '#2F2E2D',
    cardBg: '#3D3D3D',
    cardBg2: '#191326',
    cardBg3: '#51535E',
    cardBg4: '#2F2E2D',
    cardBg5: '#332525',
    primary: '#EE9715',
    secondary: '#FFF',
    normal: '#FFF',
    inputBg: '#2F2E2D',
    strokColor: '#2F2E2D',
    navBg: '#2F2E2D',
  }
}
